export function smallUSPSCarousel() {

	let carousel        = $('.js-small-usps-carousel');
	let windowWidth     = $(window).width();

	if(windowWidth < 768) {
		carousel.addClass('owl-carousel owl-theme');
		carousel.owlCarousel({
			items: 1,
			autoWidth: true,
			nav: false,
			dots: false,
			margin: 30
		});
	} else {
		carousel.trigger('destroy.owl.carousel');
		carousel.removeClass('owl-carousel owl-theme');
	}


	return 'smallUSPSCarousel';
}